import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOnboardingMarketMatchLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 17,
	viewBox: "0 0 14 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.05469 3.91992H12.6789C12.9809 3.91992 13.1823 4.12127 13.1823 4.4233V7.54423",
			stroke: "black",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.699219 7.54423V4.4233C0.699219 4.12127 0.900563 3.91992 1.20258 3.91992H4.82678",
			stroke: "black",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.699219 11.7734V15.0957C0.699219 15.3977 0.900563 15.5991 1.20258 15.5991H12.6792C12.9812 15.5991 13.1826 15.3977 13.1826 15.0957V11.7734",
			stroke: "black",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.699219 11.7733H1.80661C3.01468 11.7733 3.92073 10.7665 3.92073 9.6591C3.92073 8.55168 2.91401 7.54492 1.80661 7.54492H0.699219",
			stroke: "black",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1825 7.54492H12.0751C10.867 7.54492 9.96094 8.55168 9.96094 9.6591C9.96094 10.7665 10.9677 11.7733 12.0751 11.7733H13.1825",
			stroke: "black",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.05636 3.92083V2.8134C9.05636 1.6053 8.04964 0.699219 6.94224 0.699219C5.83485 0.699219 4.82812 1.70597 4.82812 2.8134V3.92083",
			stroke: "black",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgOnboardingMarketMatchLogo;
